import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../CSS/navbar.css";

export default function NavbarLoggedOut() {
  const [className, setClass] = useState("nav-link");
  const handleScroll = () => {
    if (window.scrollY > 0) {
      setClass("nav-link scrolled");
    } else {
       setClass("nav-link");
    }
  }
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <ul className="navbar-nav mt-2 mt-lg-0">
      <li className="nav-item">
        <Link
          className={className}
          to="/home"
        >
          <i className="fas fa-home"></i> Home
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className={className}
          to="/aboutus"
        >
          <i className="fas fa-users"></i> About Us
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className={className}
          to="/request-status"
        >
          <i className="fas fa-search"></i> Request Status
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className={className}
          to="/login"
        >
          <i className="fas fa-sign-in-alt"></i> Login
        </Link>
      </li>
      <li className="nav-item">
        <Link
          className={className}
          to="/register"
        >
          <i className="fas fa-user-plus"></i> Register
        </Link>
      </li>
    </ul>
  );
}
